// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.topBar {
  display: flex;
  height: 100px;
  width: 100vw;
  flex-direction: row;
  justify-content: space-between;
  background-color: #363636;
  align-items: center;
  z-index: 1004;
  box-shadow: 0px 5px 6px 0px rgba(157, 157, 157, 1);
}

.topBarLogo {
  width: 70px;
  height: 70px;
  margin-left: 10px;
}

.topBarMenuIcon {
  width: 40px;
  height: 40px;
  margin-right: 20px;
  cursor: pointer;
  color: #ffffff;
  transform: rotate(0.25turn);
}

.topBarMenuIconOpen {
  transform: rotate(0.75turn);
}

.topBarMenuContainer {
  width: 200px;
  position: absolute;
  top: 80px;
  right: 20px;
  background-color: #f6f6f4;
  border-radius: 5px;
  border: 1px solid #c0c0c0;
  display: none;
  flex-direction: column;
  z-index: 1000;
  box-shadow: -11px 13px 24px -17px rgba(66, 68, 90, 1);
}

.topBarMenuUserInfoUsername {
  display: flex;
  flex-direction: row;
  align-items: center;
  color: #ffffff;
}

.topBarMenuItem {
  padding: 10px;
  cursor: pointer;
  text-align: center;
}

.topBarMenuItem:hover {
  background-color: #f5cacb;
  border-radius: 5px;
}

.topBarMenuUserInfoContainer {
  display: flex;
  flex-direction: column;
  padding: 10px;
  align-items: center;
}

.topBarMenuUserInfoAvatar {
  width: 40px;
  height: 40px;
  border-radius: 20px;
  margin-right: 10px;
}

.topBarTenantName {
  color: #ffffff;
  font-size: 30px;
}

.topBarUserInfo {
  display: flex;
  flex-direction: row;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/components/TopBar/TopBar.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EAGb,kDAAkD;AACpD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,aAAa;EAGb,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB","sourcesContent":[".topBar {\n  display: flex;\n  height: 100px;\n  width: 100vw;\n  flex-direction: row;\n  justify-content: space-between;\n  background-color: #363636;\n  align-items: center;\n  z-index: 1004;\n  -webkit-box-shadow: 0px 5px 6px 0px rgba(157, 157, 157, 1);\n  -moz-box-shadow: 0px 5px 6px 0px rgba(157, 157, 157, 1);\n  box-shadow: 0px 5px 6px 0px rgba(157, 157, 157, 1);\n}\n\n.topBarLogo {\n  width: 70px;\n  height: 70px;\n  margin-left: 10px;\n}\n\n.topBarMenuIcon {\n  width: 40px;\n  height: 40px;\n  margin-right: 20px;\n  cursor: pointer;\n  color: #ffffff;\n  transform: rotate(0.25turn);\n}\n\n.topBarMenuIconOpen {\n  transform: rotate(0.75turn);\n}\n\n.topBarMenuContainer {\n  width: 200px;\n  position: absolute;\n  top: 80px;\n  right: 20px;\n  background-color: #f6f6f4;\n  border-radius: 5px;\n  border: 1px solid #c0c0c0;\n  display: none;\n  flex-direction: column;\n  z-index: 1000;\n  -webkit-box-shadow: -11px 13px 24px -17px rgba(66, 68, 90, 1);\n  -moz-box-shadow: -11px 13px 24px -17px rgba(66, 68, 90, 1);\n  box-shadow: -11px 13px 24px -17px rgba(66, 68, 90, 1);\n}\n\n.topBarMenuUserInfoUsername {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  color: #ffffff;\n}\n\n.topBarMenuItem {\n  padding: 10px;\n  cursor: pointer;\n  text-align: center;\n}\n\n.topBarMenuItem:hover {\n  background-color: #f5cacb;\n  border-radius: 5px;\n}\n\n.topBarMenuUserInfoContainer {\n  display: flex;\n  flex-direction: column;\n  padding: 10px;\n  align-items: center;\n}\n\n.topBarMenuUserInfoAvatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 20px;\n  margin-right: 10px;\n}\n\n.topBarTenantName {\n  color: #ffffff;\n  font-size: 30px;\n}\n\n.topBarUserInfo {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
